import { styled } from 'styled-components'
import { mediaDesktop, mediaMobile } from './styles/breakPoints'

const Header = styled.div`
  font-weight: ${p => p.theme.font.weight.bold};
  color: var(--themeColorBluePrimary);
  text-transform: uppercase;
  text-align: center;
  padding: 16px 112px;
  justify-content: space-between;
  align-items: center;
  ${mediaMobile} {
    margin: 0 auto;
    max-width: 300px;
    padding: 24px 16px;
  }
  ${mediaDesktop} {
    font-size: ${p => p.theme.font.size.title};
    padding-top: 32px;
  }
`

export default Header
